import readMore from "utils/read-more"

const CONTAINER_SELECTOR = "[data-forecast-text-summary-container]"

let requestSequence = 0

function currentUnits() {
  if (window.unitsConv && window.unitsConv.currentUnits) return window.unitsConv.currentUnits
  if (document.body.classList.contains("current-units-i")) return "i"
  if (document.body.classList.contains("current-units-m")) return "m"

  return document.body.classList.contains("js-units-i") ? "i" : "m"
}

function initReadMore(root) {
  Array.from(root.querySelectorAll("[data-read-more]")).forEach((el) => readMore(el))
}

function updateForecastTextSummary() {
  const container = document.querySelector(CONTAINER_SELECTOR)

  if (!container) return

  const units = currentUnits()

  if (!units || container.dataset.currentUnits === units) return

  const url = container.dataset.forecastTextSummaryUrl

  if (!url) return

  requestSequence += 1
  const sequence = requestSequence
  const separator = url.includes("?") ? "&" : "?"

  fetch(`${url}${separator}units=${encodeURIComponent(units)}`, {
    credentials: "same-origin",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  })
    .then((response) => response.text())
    .then((html) => {
      if (sequence !== requestSequence) return

      if (html.trim() === "") {
        container.remove()
        return
      }

      const replacement = document.createElement("div")
      replacement.innerHTML = html

      const nextContainer = replacement.querySelector(CONTAINER_SELECTOR)

      if (!nextContainer) return

      container.replaceWith(nextContainer)
      initReadMore(nextContainer)
    })
    .catch(() => {})
}

export default function forecastTextSummary() {
  document.addEventListener("switchUnits", () => {
    setTimeout(updateForecastTextSummary, 0)
  })
}
